/* onlyQ – Ambassador-Button auf der Produktseite
   Einzelbestellung / Abo laufen ueber die normale Variantenauswahl (Appstle).
   Ambassador ist ein eigener Button:
     - kein Ambassador -> Anmeldeformular (GoAffPro) oeffnet sich als Overlay
     - Ambassador      -> Hinweis + Link zum Dashboard
*/
(function () {
  'use strict';

  var CFG = window.oqAffiliate || {};
  var SIGNUP = CFG.signupUrl || 'https://my.onlyq.eu/create-account';
  var PORTAL = CFG.portalUrl || 'https://my.onlyq.eu';
  var IS_PARTNER = CFG.isPartner === true;
  var RABATT = CFG.discountLabel || '20 %';

  var modal = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'oq-gate';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="oq-gate__backdrop" data-oq-close></div>' +
      '<div class="oq-gate__panel" role="dialog" aria-modal="true" aria-label="Ambassador werden">' +
        '<div class="oq-gate__head">' +
          '<div>' +
            '<p class="oq-gate__eyebrow">onlyQ Ambassador</p>' +
            '<h2 class="oq-gate__title">Erst anmelden, dann als Ambassador bestellen</h2>' +
          '</div>' +
          '<button type="button" class="oq-gate__close" data-oq-close aria-label="Schließen">&times;</button>' +
        '</div>' +
        '<iframe class="oq-gate__frame" src="' + SIGNUP + '" title="Anmeldung als Ambassador" loading="lazy"></iframe>' +
        '<div class="oq-gate__foot">' +
          '<a class="oq-gate__link" href="' + SIGNUP + '" target="_blank" rel="noopener">In neuem Tab öffnen</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-oq-close]')) close();
    });
    return modal;
  }

  function open() {
    var m = buildModal();
    m.removeAttribute('hidden');
    document.documentElement.classList.add('oq-gate-open');
    document.addEventListener('keydown', onKey);
    var c = m.querySelector('.oq-gate__close');
    if (c) c.focus();
  }

  function close() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('oq-gate-open');
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  }

  function buildButton() {
    var wrap = document.createElement('div');
    wrap.className = 'oq-aff';

    if (IS_PARTNER) {
      wrap.innerHTML =
        '<a class="oq-aff__btn oq-aff__btn--partner" href="' + PORTAL + '" target="_blank" rel="noopener">' +
          'Dein Ambassador-Vorteil ist aktiv' +
        '</a>' +
        '<p class="oq-aff__note">' + RABATT + ' werden ab 100 Euro Bestellwert direkt auf der Rechnung abgezogen, auf dein eigenes Abo 10 %. Zu deinem Dashboard &rarr;</p>';
    } else {
      wrap.innerHTML =
        '<button type="button" class="oq-aff__btn" data-oq-gate>' +
          'Als Ambassador bestellen, ' + RABATT + ' auf deinen Einkauf' +
        '</button>' +
        '<p class="oq-aff__note">Noch kein Ambassador? Nach der Anmeldung bekommst du 20 Prozent ab 100 Euro Bestellwert je Bestellung, auf dein eigenes Abo 10 Prozent.</p>';
      wrap.querySelector('[data-oq-gate]').addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }
    return wrap;
  }

  function mount() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var host = form || document.querySelector('.product-information, .product__info, main');
    if (!host) return false;
    if (document.querySelector('.oq-aff')) return true;
    var btn = buildButton();
    if (form && form.parentNode) {
      form.parentNode.insertBefore(btn, form.nextSibling);
    } else {
      host.appendChild(btn);
    }
    return true;
  }

  function boot() {
    if (mount()) return;
    var tries = 0;
    var obs = new MutationObserver(function () {
      if (mount() || ++tries > 60) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
